import { AssetReq, RankingDef } from "../../type/asset";

export class RankingAdapter {
  static toInputDTO(req: AssetReq): any {
    const selectedNode = req.node_attrs.find((attr) => attr.value);
    return {
      node: selectedNode ? selectedNode.key : null,
      is_past_look: true,
    };
  }

  static toOutputDTO(res: any): RankingDef {
    let ranking1 =
      res?.covariant?.map((item: any) => ({
        id: item.rank,
        key: item.label,
      })) || [];
    let ranking2 =
      res?.treatment?.map((item: any) => ({
        id: item.rank,
        key: item.label,
      })) || [];

    ranking1 = ranking1.slice(0, 10);
    ranking2 = ranking2.slice(0, 10);

    for (let i = ranking1.length; i < 10; i++) {
      ranking1.push({ id: i + 1, key: null });
    }
    for (let i = ranking2.length; i < 10; i++) {
      ranking2.push({ id: i + 1, key: null });
    }

    return [
      { id: 1, key: "dashboard-new-asset-ranking-title1", values: ranking1 },
      { id: 2, key: "dashboard-new-asset-ranking-title2", values: ranking2 },
    ];
  }
}
